import { Component, OnInit } from "@angular/core";
import { Client } from "src/app/services/API/client";
import { toastrService } from "src/app/services/ux/toastr.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { SetTitleService } from "src/app/services/set-title.service";


@Component({
  templateUrl: "./edit-password.component.html"
})
export class EditPasswordComponent implements OnInit {
  form: FormGroup; // Formi i te dhenave

  constructor(
    private client: Client,
    private toastr: toastrService,
    private fb: FormBuilder,
    private settitleservice : SetTitleService
  ) {
    // formi i change password
    this.form = this.fb.group({
      oldpass: ["", Validators.required],
      newpass: ["", Validators.required],
      newpassconf: ["", Validators.required]
    });
  }

  ngOnInit() {
    this.settitleservice.sendTitle("Change Password");
  }

  // PastronFushat e Formit
  emptyFields() {
    this.form.reset();
  }

  // therrasim API per te ndryshuar passwordin
  changePassword() {
    if (
      typeof this.form.value.oldpass === "undefined" ||
      this.form.value.oldpass === "" ||
      typeof this.form.value.newpass === "undefined" ||
      this.form.value.newpass === "" ||
      typeof this.form.value.newpassconf === "undefined" ||
      this.form.value.newpassconf === ""
    ) {
      return this.toastr.error("Plotesoni Fushat");
    }

    const passRegex = /^(?:(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*)$/;

    if (this.form.value.newpass !== this.form.value.newpassconf) {
      return this.toastr.error(
        "Kujdes!Fjalekalimi i ri dhe konfirmimi i tij nuk jane te njejte"
      );
    } else if (!passRegex.test(this.form.value.newpass)) {
      return this.toastr.error(
        "Fjalëkalimi duhet të përmbaje të paktën një shkronjë të madhe dhe një numër."
      );
    } else if (!this.form.value.newpass || this.form.value.newpass.length < 6) {
      return this.toastr.error(
        "Fjalëkalimi duhet të ketë të paktën 6 karaktere."
      );
    }

    this.client
      .post("api/user/changePassword", {
        oldPassword: this.form.value.oldpass,
        newPassword: this.form.value.newpass
      })
      .then((res: any) => {
        if (res === "success") {
          this.toastr.success("Passwordet u ndryshuan me sukses");
          this.emptyFields();
        } else {
          this.toastr.error("Ka ndodhur nje gabim");
        }
      })
      .catch((err: any) => {
        // erroret ne authentikim
        let message: string;

        // check error status
        if (err.error === "wrong_old_password") {
          message = "Fjalekalimi i vjeter eshte i gabuar";
        } else if (err.error === "user_not_exist") {
          message = "Perdoruesi nuk ekziston";
        } else if (err.error === "old_password_is_same_as_new_password") {
          message =
            "Fjalëkalimi ekzistues nuk mund të jetë i njëjtë me fjalëkalimin e ri.";
        } else {
          message = "Ka ndodhur nje gabim ne server";
        }

        // display modal
        this.toastr.error(message);
      });
  }
}
